<div class="d-flex carrousel mb-3"
     [ngClass]="{
        'Declined' : certificate.status === 'Expired' || certificate.status === 'Not-refunded',
        'Accepted' : certificate.status === 'Accepted' || certificate.status === 'Canceled' || certificate.status === 'Refund-failed',
        'Expired': certificate.status === 'Refunded',
        'Pending': certificate.status.includes('Pending')
        }">
  <div class="attestPicture d-flex justify-content-center align-items-center">
    <div class="picto" *ngIf="certificate.status !== 'Expired'">
      <img alt="" height="50"
           ngSrc="https://livinfrance-bk.s3.eu-west-3.amazonaws.com/school/process-picto/HOUSING-CERTIFICATE.svg"
           width="50">
    </div>
  </div>
  <div class="description d-flex flex-column justify-content-center text_3">

    <p class="text_4 lh-1">
      {{ certificate.status === 'Accepted' || certificate.status === 'Canceled' ? certificate.total + '€' : (('COMMON.PROCESS_STATUS.' + certificate.status.toUpperCase()) | translate) }}
    </p>
    <p class="minitext_1 text-danger mb-2" *ngIf="certificate.refundDatas && certificate.refundDatas.reason && certificate.status == 'Not-refunded'"
       (click)="openModal(refusalModale)">
      {{ 'PROCESSES.HOUSING_CERTIFICATE.REFUSAL_REASON.' + certificate.refundDatas.reason | translate }}
      <mat-icon class="font-11 align-content-end pointer">help</mat-icon>
    </p>

    <p class="mb-3 mt-2">{{'COMMON.USER.HOUSING_CERTIFICATE' | translate }}: {{certificate['city']}}</p>

    <p>{{'COMMON.USER.RESERVATION_MADE' | translate }}
      : {{certificate['created_at'] | date:(locale == 'fr' ?'dd/MM/yyyy' : 'MM/dd/yyyy' )}}
    </p>

    <p class="mb-3">{{'COMMON.USER.RESERVATION_ID' | translate }}: {{certificate.id}}</p>

    <button type="button" role="button" class="btn btn-primary fw-bold" *ngIf="showButton && certificate.status !== 'Not-refunded'"
            (click)="goToHousingCertificate(certificate)">
      {{(certificate.status === 'Expired' ? 'COMMON.USER.REDO_CERTIFICATE' : 'COMMON.USER.VIEW_CERTIFICATE') | translate }}
    </button>

  </div>
</div>

<ng-template #refusalModale let-modal>
  <div class="mt-4 px-4 d-flex align-items-center">
    <h5 class="font-trueno-bold font-28 fw-bold">{{ text.title | translate }}</h5>
    <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
      <span class="material-icons-outlined text-black">close</span>
    </button>
  </div>

  <div class="pb-4 mt-2 px-4 pt-2">
    @if (text.subtitle) {
      <h6 class="title_2" *ngIf="text.subtitle"> {{ text['subtitle'] | translate }} </h6>
    }

    <p class="text_3 my-2" [innerHTML]="text.text | translate"></p>

    <a [href]="contactFormUrl" target="_blank" class="btn btn-secondary mt-4">
      {{ 'PROCESSES.ACCOMMODATION.POST_RESERVATION.CONTACT_ERROR_BUTTON' | translate }}
    </a>
  </div>
</ng-template>
